import React, { memo, Children, ReactElement, cloneElement } from 'react'
import { useSelector } from 'react-redux'
import { Moment } from 'moment-timezone'
import { DriversEmpty } from 'apps/fleet-planner/components/fleet/DriversEmpty'
import { selectDrivers } from 'apps/fleet-planner/utils/selectors'
import { ICalendarRowProps } from './CalendarRow'
import { NowNeedle } from './Now'

interface ICalendarBodyHoursProps {
  day: Moment
  nbOfHours: number
}

export const CalendarBodyHours = memo<ICalendarBodyHoursProps>(({ day, nbOfHours }) => {
  const TODAY = new Date()
  const isToday = day.isSame(TODAY, 'day')
  const daysArr: JSX.Element[] = []
  for (let i = 0; i < nbOfHours; i += 1) {
    daysArr.push(<div />)
  }
  return (
    <div className='calendar-view-day-column'>
      <div className='calendar-view-day-grid'>{daysArr}</div>
      {isToday && <NowNeedle />}
    </div>
  )
})

interface ICalendarBodyProps extends JSX.ElementChildrenAttribute {
  days: Moment[]
  loading?: boolean
}

export const CalendarBody = memo<ICalendarBodyProps>(({ children, days, loading }) => {
  const driversList = useSelector(selectDrivers)
  const edges: [Moment, Moment] = [
    days[0].clone().startOf('d'),
    days[days.length - 1].clone().endOf('d'),
  ]
  // If displaying > 1 day, only display 3 hours indicators
  const nbOfDisplayedHours = days.length > 1 ? 3 : 24
  return (
    <div className='calendar-view-body'>
      {!driversList.length ? <DriversEmpty /> : undefined}
      <div className='calendar-view-body-grid'>
        <div className='calendar-view-legend-column' />
        {days.map((day: Moment) => (
          <CalendarBodyHours day={day} nbOfHours={nbOfDisplayedHours} key={day.valueOf()} />
        ))}
      </div>
      {/* <div className='calendar-view-scroll-container'> */}
      <div className='calendar-view-scroll-container'>
        {Children.map(
          (children as ReactElement[]).filter(Boolean),
          (child: ReactElement<ICalendarRowProps>) =>
            cloneElement(child as ReactElement<ICalendarRowProps>, { edges, loading, days })
        )}
      </div>
    </div>
  )
})
